import { t } from 'i18next';
import { debounce } from 'lodash';
import { UsersApi } from 'services/users/users.api';
import * as Yup from 'yup';

const debouncePromise = <T>(fn: (...args: any[]) => Promise<T>, delay: number) => {
  const debouncedFn = debounce((resolve, reject, ...args) => {
    fn(...args).then(resolve).catch(reject);
  }, delay);

  return (...args: any[]): Promise<T> =>
    new Promise((resolve, reject) => {
      debouncedFn(resolve, reject, ...args);
    });
};

const verifyEmailWithDebounce = debouncePromise<boolean>(async (email: string = '') => {
  if (!email) {
    return false;
  }

  const registeredData = await UsersApi.verifyEmail({ email });
  return Object.values(registeredData.registeredAccounts).every(
    (signOption) => signOption === false,
  );
}, 500);

export const changeEmailSchema = Yup.object({
  email: Yup.string()
    .required(t('required'))
    .email(t('invalidFormat'))
    .test(
      'email-already-exists-validation',
      t('emailAlreadyExistsError'),
      async (email) => verifyEmailWithDebounce(email),
    ),
});
